<template>
  <div>
    <blast-student :blast="assignment" v-if="assignment"></blast-student>
  </div>
</template>

<script>
  import BlastStudent from '@/components/BlastStudent'
  export default {
    name: 'AssignmentsDetail',
    components: { BlastStudent },
    routeConfig: {
      name: "assignmentDetail", path: "/assignments/:id", meta: { fullMainContainer: true }
    },
    metaInfo () {
      return {
        title: this.assignmentTitle
      }
    },
    data () {
      return {
        assignment: null //this.$store.get('userAssignments', this.$route.params.id)
      }
    },
    created () {
      if(this.$route.params.id == 'preview') {
        let vm = this
        $(window).on("message.blastDetail", (event) => {
          const origin = _.get(event, "originalEvent.origin")
          const source = _.get(event, "originalEvent.source")
          if (origin !== vm.$classicParams.origin || event.originalEvent.source !== window.parent) {
            return
          }
          let ua = _.get(event, "originalEvent.data.userAssignment")
          if (ua) {
            this.assignment = vm.$store.inject('userAssignments', ua)
          }
        })
        window.parent.postMessage("ready", vm.$classicParams.origin)
      } else {
        this.$store.find('userAssignments', this.$route.params.id)
          .then((assignment) => {
            this.assignment = assignment
          })
          .catch((err) => {
            this.$router.push({name: "assignments"})
          })
      }
    },
    computed: {
      assignmentTitle () {
        return _.get(this.assignment, "assignment.name") || ""
      }
    },
    beforeDestroy () {
      $(window).off('.blastDetail')
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  color:blue;
}
</style>



// WEBPACK FOOTER //
// src/routes/Assignments/Detail.vue